import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{svg-jar \"chevron-down\"}}\n",{ moduleName: "frontend/components/twilio/sidebar/scroll-arrow.hbs" })